export enum RhesusFactor {
    Plus = 0,
    Minus = 1
}